import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import "./LoadingGlobal.scss"

function LoadingGlobal({ loadingGlobal }) {
    return (
        <>
            {loadingGlobal == true ? (
                <Card className='contenedorLoading'>
                    <ProgressSpinner className=" loadingSpinner" />
                </Card>)
                : ""}
        </>
    )
}

export default LoadingGlobal